import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useState, useEffect } from 'react';
import { FrontSide, LinearFilter, TextureLoader } from 'three';
import pause from '../assets/pause.svg';
import play from '../assets/play.svg';
import { getSvgCanvas } from '../CurvedEntity/canvasTexture';
import CurvedEntity from '../CurvedEntity/CurvedEntity';
import { getRadiusFromCurvature, getSnapEntityCurvatureOnTarget } from '../CurvedEntity/gizmoUtil';
const PlayPauseButton = ({ scale, showPlayIcon, entityWidth, renderOrder, raycast, curvature, visible, depthTest }) => {
    const [texture, setTexture] = useState();
    const svgUrl = showPlayIcon ? play : pause;
    useEffect(() => {
        if (!svgUrl)
            return;
        const getData = async () => {
            const image = await getSvgCanvas(svgUrl);
            const imageTexture = new TextureLoader().load(image);
            imageTexture.minFilter = imageTexture.magFilter = LinearFilter;
            setTexture(imageTexture);
        };
        getData();
    }, [svgUrl]);
    // The play/pause button needs a different curvature than the parent entity, because it has different dimensions
    const radiusForEntity = getRadiusFromCurvature(curvature, entityWidth);
    let buttonCurvature = getSnapEntityCurvatureOnTarget(radiusForEntity, [entityWidth * 0.2, 1, 1]);
    buttonCurvature = Math.abs(buttonCurvature) * Math.sign(curvature);
    // Adjustments for the play / pause SVG parts
    const svgPos = showPlayIcon
        ? [scale[0] * 0.1, -scale[1] * 0.15, 0]
        : [scale[0] * 0.05, -scale[1] * 0.075, 0];
    return (_jsxs(_Fragment, { children: [_jsx(CurvedEntity, { name: "Play Button ( Background )", raycast: raycast, scale: scale, cornerRadius: 0.2, renderOrder: renderOrder, opacity: 0.4, colorRgba: [0, 0, 0, 1], curvature: buttonCurvature, hasAlpha: true, depthTest: depthTest, visible: visible, side: FrontSide }, 'video_center_btn_bkgr'), texture && (_jsx(CurvedEntity, { name: "Play Button ( SVG )", raycast: raycast, position: svgPos, scale: showPlayIcon ? scale : [scale[0] / 2, scale[1] / 2, scale[2] / 2], renderOrder: renderOrder + 1, opacity: 1, curvature: buttonCurvature, imageTexture: texture ? texture : undefined, cornerRadius: 0, hasAlpha: true, depthTest: depthTest, visible: visible, side: FrontSide }, 'video_center_btn_play'))] }));
};
export default memo(PlayPauseButton);
